import { RoleModel } from '../../../security/models/RoleModel';
import { ActionBase } from '../../../core/store/action/ActionBase';

export const ADD_ROLE_TO_USER = '[Customer] User Add Role';

export class AddRoleToUserAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = ADD_ROLE_TO_USER;

  constructor(public payload: { userKey: string, role: RoleModel }) { }
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/AddRoleToUserAction.ts